var _a;
import { Language } from 'src/shared/constants/languages';
class NumberHelper {
    constructor() {
        Object.defineProperty(this, "_locale", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: Language.En
        });
    }
    static getInstance() {
        if (!_a._instance) {
            _a._instance = new _a();
        }
        return _a._instance;
    }
    static getLocale() {
        return this.getInstance()._locale;
    }
}
_a = NumberHelper;
Object.defineProperty(NumberHelper, "setLocale", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: (locale) => {
        _a.getInstance()._locale = locale;
    }
});
Object.defineProperty(NumberHelper, "format", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: (value, options) => {
        try {
            return new Intl.NumberFormat(_a.getInstance()._locale, options).format(value);
        }
        catch {
            return `${value}`;
        }
    }
});
Object.defineProperty(NumberHelper, "formatCurrency", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: (amount, currencyCode) => {
        return new Intl.NumberFormat(_a.getInstance()._locale, {
            style: 'currency',
            currency: currencyCode
        }).format(amount);
    }
});
export default NumberHelper;
